export default __webpack_public_path__ + "static/media/sticker-U.997cf440.png";